
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import RegisterModal from "@/components/modals/RegisterModal";
import { useTranslation } from 'react-i18next';

const CTA = () => {
  const { t } = useTranslation();

  return (
    <section 
      className="gradient-hero-section rounded-xl p-8 md:p-12 text-white text-center dark:text-white"
      aria-labelledby="cta-heading"
    >
      <div className="max-w-2xl mx-auto space-y-6">
        <h2 className="text-3xl font-bold text-white dark:text-white" id="cta-heading">{t('cta.title')}</h2>
        <p className="text-white/90 dark:text-white/90">
          {t('cta.description')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <RegisterModal>
            <Button 
              size="lg" 
              className="bg-green-500 hover:bg-green-600 text-white border-0"
              aria-label={t('cta.create_account_aria')}
            >
              {t('cta.create_account')}
            </Button>
          </RegisterModal>
          <Button 
            size="lg" 
            variant="outline" 
            className="bg-transparent text-white border-white hover:bg-white/20 hover:text-white" 
            asChild
            aria-label={t('cta.psychologist_register_aria')}
          >
            <Link to="/psychologist-register">{t('cta.psychologist_register')}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTA;
